var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndorIdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 22,
    viewBox: "0 0 52 22",
    fill: "none",
    m_init: 2270459202510131700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4878 12.099L24.7188 13.416H15.8668L15.1298 12.099L9.29783 22L7.99783 21.994C7.18083 21.994 6.46583 21.597 6.06283 20.898L2.98783 15.561H10.5018L11.2438 16.496L15.8658 8.589H24.7238L25.4878 9.895C25.8958 10.6 25.8958 11.4 25.4878 12.099ZM23.3808 15.561L20.3108 20.898C19.9028 21.597 19.1878 21.994 18.3708 21.994H17.0708L15.1298 18.694L13.8348 20.898L14.4798 21.994H11.8888L15.8718 15.56H23.3808V15.561ZM0.886828 9.901L1.64983 8.589H10.5018L11.2438 9.901L17.0708 0L18.3708 0.00600004C19.1938 0.00600004 19.9088 0.403 20.3118 1.108L23.3808 6.445H15.8718L15.1298 5.504L10.5018 13.416H1.64983L0.886828 12.104C0.477828 11.4 0.477828 10.605 0.886828 9.901ZM2.98783 6.445L6.06283 1.108C6.46583 0.403 7.18583 0.00600004 8.00283 0.00600004H9.30383L11.2438 3.306L12.5388 1.102L11.8948 0.00600004H14.4798L10.5018 6.445H2.98783Z",
    fill: "#00469A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0059 20.003V2H34.0049V20.003H31.0059ZM48.5339 10.911C48.5339 9.437 48.2989 8.222 47.8369 7.269C47.3749 6.315 46.6939 5.609 45.7949 5.147C44.8959 4.68 43.7909 4.449 42.4759 4.449H39.9549V17.525H42.0469C44.2189 17.525 45.8449 16.97 46.9209 15.865C47.9959 14.756 48.5339 13.105 48.5339 10.911ZM51.6099 10.827C51.6099 12.853 51.2319 14.546 50.4799 15.907C49.7239 17.264 48.6269 18.285 47.1899 18.97C45.7529 19.655 44.0219 20 41.9969 20H37.0009V2H42.5389C44.3999 2 46.0089 2.336 47.3619 3.004C48.7189 3.672 49.7649 4.659 50.4999 5.97C51.2399 7.281 51.6099 8.899 51.6099 10.827Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndorIdLogo);
export default __webpack_public_path__ + "static/media/indor_id_logo.70c83212578b54aa59decc70a02d5539.svg";
export { ForwardRef as ReactComponent };